import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import EsimsHorizontalScroll from "../../components/Esim/EsimsHorizontalScroll/EsimsHorizontalScroll";
import EsimActionsSection from "../../components/Esim/EsimActionsSection/EsimActionsSection";
import EmptyEsimView from "../../components/Esim/EmptyEsimView/EmptyEsimView";
import Select from "../../components/Elements/Select/Select";
import { fetchUserEsims } from "../../services/EsimService";
import emptySimIcon from "../../assets/icons/cart/sim-card.png";

import filterIcon from "../../assets/icons/data/filter.png";
import "./Esim.css";

const FILTER_PARAMS = {
  current: { deleted: false, archived: false },
  archived: { deleted: false, archived: true },
  deleted: { deleted: true },
};

const EsimScreen = () => {
  const { t, i18n } = useTranslation();
  const [esims, setEsims] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalAll, setTotalAll] = useState(null);
  const [selectedEsim, setSelectedEsim] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("current");

  const filterOptions = [
    { value: "current", label: t("esim.current") || "Current" },
    { value: "archived", label: t("esim.archived") || "Archived" },
    { value: "deleted", label: t("esim.deleted") || "Deleted" },
  ];

  const loadEsims = (activeFilter) => {
    setLoading(true);
    const params = {
      ...FILTER_PARAMS[activeFilter],
      language: i18n.resolvedLanguage,
    };
    fetchUserEsims(params)
      .then((data) => {
        const items = data.items || [];
        setEsims(items);
        setTotal(data.total ?? items.length);
        setSelectedEsim(items[0] ?? null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchUserEsims({})
      .then((data) => setTotalAll(data.total ?? 0))
      .catch(() => setTotalAll(0));
  }, []);

  useEffect(() => {
    loadEsims(filter);
  }, []);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    loadEsims(newFilter);
  };

  if (loading) return <div className="loading">{t("common.loading")}</div>;

  const hasEsims = total > 0;
  const hasAnyEsims = totalAll === null || totalAll > 0;

  return (
    <div className="esim-screen">
      <PageHeader title={t("esim.title")} description={t("esim.subtitle") || "Install, top-up and manage all your eSIM profiles in one place"} />

      <div className="esim-filter-bar">
        <img src={filterIcon} alt="filter" className="esim-filter-icon" />
        <Select value={filter} onChange={handleFilterChange} options={filterOptions} />
      </div>

      {hasEsims ? (
        <>
          <EsimsHorizontalScroll
            esims={esims}
            selectedEsim={selectedEsim}
            onSelectedEsimChange={setSelectedEsim}
            filter={filter}
            onRefresh={() => loadEsims(filter)}
          />
          {selectedEsim && <EsimActionsSection selectedEsim={selectedEsim} />}
        </>
      ) : hasAnyEsims ? (
        <div className="esim-empty-container">
          <section className="esim-empty-content">
            <img src={emptySimIcon} alt="" className="esim-empty__img" aria-hidden="true" />
            <h2 className="esim-empty__title">{t("esim.noEsims")}</h2>
          </section>
        </div>
      ) : (
        <EmptyEsimView />
      )}
    </div>
  );
};

export default EsimScreen;
